import React, { Component } from 'react'
import Button from 'components/button/button'
import { CSSTransitionGroup } from 'react-transition-group'
import { doClickEventListeners } from 'utils'

export default class BrainModal extends Component {
	hasAttachedListeners = false

	UNSAFE_componentWillUpdate = nextProps => {
		if(!this.hasAttachedListeners && !this.props.data && nextProps.data){
			this.hasAttachedListeners = true
			doClickEventListeners(this.assessCloseBrainModal)
		}else if(this.hasAttachedListeners && this.props.data && !nextProps.data){
			this.hasAttachedListeners = false
			doClickEventListeners(this.assessCloseBrainModal, true)
		}
	}

	assessCloseBrainModal = e => {
		if(this.ref && !this.ref.contains(e.target)) {
			// stopPropagation doesn't seem to work in this instance, so it'll need to wait for a potential <button> click.
			this.props.closeCallback()
		}
	}

	render() {
		const {
			data,
			closeCallback,
			direction
		} = this.props

		return (
			<CSSTransitionGroup 
				transitionName="brain" 
				transitionEnterTimeout={300} 
				transitionLeaveTimeout={300}
				className="brain-modal-container"
			>
				{ data && data.isVisible ? 
					<div 
						className={"brain-modal "+direction}
						ref={ref => this.ref = ref}
					>
						<p dangerouslySetInnerHTML={{ __html: data.suggestion }} />
						<Button 
							size={'big'} 
							level={'low'} 
							callback={e => {
								e.stopPropagation()
								closeCallback(true)
							}} 
							label={'Sure!'} 
						/>
					</div>
					: null
				}
			</CSSTransitionGroup>
		)
	}
}
